export default "__VITE_ASSET__h2sB0Z_z__"